import {
  SSAcquisitionDataLayerObject,
  SSDataLayer,
  SSFormDataLayerObject,
  SSPageDataLayerObject,
} from "@pages/ShieldStarter/DataLayer/DataLayer.model";
import { Helpers } from "./helpers";
import { store } from "@redux/store";
import { DSAcquisitionDataLayerObject, DSDataLayer, DSFormDataLayerObject, DSUserDataLayerObject } from "@pages/EverGreen/DataLayer/Datalayer.model";
import { CCPAcquisitionDataLayerObject, CCPCTADataLayerObject, CCPDataLayer, CCPFormDataLayerObject, CCPPageDataLayerObject, CCPUserDataLayerObject } from "@pages/CCP/DataLayer/Datalayer.model";
import { PLANS_NAME } from "@static/config";

declare const window: any;

export enum TrackType {
  PAGE_LOAD = "track_page_load",
  FORM_COMPLETE = "track_form_complete",
  PURCHAS_SUCCESSFUL = "track_purchase_success",
  FORM_ERROR = "track_form_error",
  FORM_START = "track_form_start",
  CTA_CLICK = "track_cta_click",
}

enum sessionStorageConstant {
  name = "singlife_aa_cached",
}

export class AA {
  public digitalData: SSDataLayer | DSDataLayer | CCPDataLayer = new SSDataLayer({});

  private static instance: AA;
  private failed: any;
  private constructor(initial: any) {
    const currentPolicyFlow = store.getState().loading.CurrentPolicyFlow.policy

    if (initial) {
      // console.log("initial",initial);
      switch(currentPolicyFlow){
        case "EVER_GREEN":{
          this.digitalData = new DSDataLayer(JSON.parse(initial));
          break;
        }
        case "CANCER_COVER_PLUS":{
          this.digitalData = new CCPDataLayer(JSON.parse(initial))

          break;
        }
        default: {
          this.digitalData = new SSDataLayer(JSON.parse(initial));
        }
      
      }
    } else {

      let page = new SSPageDataLayerObject({});
      let form = new SSFormDataLayerObject({});
      let acquisition :any  = new SSAcquisitionDataLayerObject({}) as any
      let user = new DSUserDataLayerObject({})
      let cta = null;
      switch(currentPolicyFlow){
       case "EVER_GREEN":{
          page = new SSPageDataLayerObject({brand: 'Singlife' });
          form = new DSFormDataLayerObject({})
          acquisition= new DSAcquisitionDataLayerObject({})
         this.digitalData = new DSDataLayer({ acquisition, page, form,user });

        break;
       }
       case PLANS_NAME.CANCER_COVER_PLUS:
        {
          page = new CCPPageDataLayerObject({brand: "Singlife"})
          cta = new CCPCTADataLayerObject({});
          acquisition = new CCPAcquisitionDataLayerObject({})
          user = new CCPUserDataLayerObject({})
          form = new CCPFormDataLayerObject({})

        // form = new 
        this.digitalData = new CCPDataLayer({page, cta, acquisition, form, user})
      
        break;
       }
       default:{
         page = new SSPageDataLayerObject({});
         form = new SSFormDataLayerObject({});
         acquisition = new SSAcquisitionDataLayerObject({});
         this.digitalData = new SSDataLayer({ acquisition, page, form });
       }

      }
    }
  }

  public static getInstance(): AA {
    if (!AA.instance) {
      const now = new Date().getTime();
      const initial = sessionStorage.getItem(sessionStorageConstant.name);
      const persisExpiredTime = sessionStorage.getItem("persist:expired") || 0;
      if (now > Number(persisExpiredTime) || !persisExpiredTime) {
        AA.instance = new AA(null);
      } else {
        AA.instance = new AA(initial);
      }
    }
    return AA.instance;
  }

  public trackFormCompleted(data: object, isError: string): void {
    Object.assign(this.digitalData, data);
    const type =
      isError === "error" ? TrackType.FORM_ERROR : TrackType.FORM_COMPLETE;
    if (window._satellite) {
      try {
        window.digitalData = this.digitalData;
        window._satellite.track(type);
        this.failed = null;
         if(window?.location?.host?.includes('uat-directsales.singlife.com') || window?.location?.host?.includes('localhost'))
          console.info("adobe",type,window.digitalData.page.errorCode && "error-",window.digitalData.page.errorCode,"Payload" ,window.digitalData )



        // console.debug({ type: type, digitalData: this.digitalData, form: this.digitalData.form.name });
      } catch (e) {
        this.retry(() => this.trackFormCompleted(data, type));
      }
    } else {
      // console.error('AA script not loaded', { type: type, digitalData: this.digitalData, form: this.digitalData.form.name });
      this.retry(() => this.trackFormCompleted(data, type));
    }
    sessionStorage.setItem(
      sessionStorageConstant.name,
      JSON.stringify(this.digitalData)
    );
  }
  public trackPurchasSuccessful(data: object): void {
    Object.assign(this.digitalData, data);
    const type = TrackType.PURCHAS_SUCCESSFUL;
    if (window._satellite) {
      try {
        window.digitalData = this.digitalData;
        window._satellite.track(type);
        this.failed = null;
         if(window?.location?.host?.includes('uat-directsales.singlife.com') || window?.location?.host?.includes('localhost'))
          console.info("adobe",type,window.digitalData.page.errorCode && "error-",window.digitalData.page.errorCode,"Payload" ,window.digitalData )

        console.debug({ type: type, digitalData: this.digitalData, form: this.digitalData.form.name });
      } catch (e) {
        this.retry(() => this.trackPurchasSuccessful(data));
      }
    } else {
      // console.error('AA script not loaded', { type: type, digitalData: this.digitalData, form: this.digitalData.form.name });
      this.retry(() => this.trackPurchasSuccessful(data));
    }
    sessionStorage.setItem(
      sessionStorageConstant.name,
      JSON.stringify(this.digitalData)
    );
  }

  // public trackFormFailed(data: object): void {
  //   Object.assign(this.digitalData, data);
  //   const type = TrackType.FORM_ERROR;
  //   if (window._satellite) {
  //     try {
  //       window.digitalData = this.digitalData;
  //       window._satellite.track(type);
  //       this.failed = null;
  //       console.debug({ type: type, digitalData: this.digitalData, form: this.digitalData.form.name });
  //     } catch (e) {
  //       this.failed = type;
  //       this.retry(() => { this.recallFailed(); });
  //     }
  //   } else {
  //     console.debug('AA script not loaded', { type: type, digitalData: this.digitalData, form: this.digitalData.form.name });
  //     this.retry(() => { this.recallFailed(); });
  //   }
  //   sessionStorage.setItem(sessionStorageConstant.name, JSON.stringify(this.digitalData));

  // }

  public trackPageLoad(data: object, nav5Tracking?:string): void {
    const navs = Helpers.getNavLevels(nav5Tracking);
    Object.assign(this.digitalData, data);
    const { page } = this.digitalData;
    Object.assign(this.digitalData, { page: { ...page, ...navs } });
    const type = TrackType.PAGE_LOAD;
    if (window._satellite) {
      try {
        window.digitalData = this.digitalData;
        window._satellite.track(type);
        this.failed = null;
         if(window?.location?.host?.includes('uat-directsales.singlife.com') || window?.location?.host?.includes('localhost')){
          const obj = JSON.parse(JSON.stringify( this.digitalData))
          console.log("Satllite digitalData harden ", type,obj)
          console.info("adobe",type,window.digitalData.page.errorCode && "error-",window.digitalData.page.errorCode,"Payload" ,window.digitalData )}

        // console.debug({ type: type, digitalData: this.digitalData, form: this.digitalData.form.name });
      } catch (e) {
        this.retry(() => this.trackPageLoad(data));
      }
    } else {
      this.failed = type;
      // console.debug('R3 AA script not loaded', { type: type, digitalData: this.digitalData, form: this.digitalData.form.name });
      this.retry(() => this.trackPageLoad(data));
    }
    sessionStorage.setItem(
      sessionStorageConstant.name,
      JSON.stringify(this.digitalData)
    );
  }
  public trackPageStart(data: object): void {
    Object.assign(this.digitalData, data);
    const type = TrackType.FORM_START;
    if (window._satellite) {
      try {
        window.digitalData = this.digitalData;
        window._satellite.track(type);
        this.failed = null;
         if(window?.location?.host?.includes('uat-directsales.singlife.com') || window?.location?.host?.includes('localhost'))
          console.info("adobe",type,window.digitalData.page.errorCode && "error-",window.digitalData.page.errorCode,"Payload" ,window.digitalData )


        // console.debug({ type: type, digitalData: this.digitalData, form: this.digitalData.form.name });
      } catch (e) {

        this.retry(() => this.trackPageStart(this.digitalData));
      }
    } else {
      this.failed = type;
      // console.debug('R3 AA script not loaded', { type: type, digitalData: this.digitalData, form: this.digitalData.form.name });
      this.retry(() => this.trackPageStart(this.digitalData));
    }
    sessionStorage.setItem(
      sessionStorageConstant.name,
      JSON.stringify(this.digitalData)
    );
  }

  public trackCTAClick(data: object, overRideType?:string): void {
    const type =overRideType || TrackType.CTA_CLICK;
    Object.assign(this.digitalData, data);

    if (window._satellite) {
      try {
        window.digitalData = this.digitalData;
        window._satellite.track(type);
        if(window?.location?.host?.includes('uat-directsales.singlife.com') || window?.location?.host?.includes('localhost')){
          const obj = JSON.parse(JSON.stringify( this.digitalData))
          console.log("Satllite digitalData harden ", type,obj)
          console.info("adobe",type,window.digitalData.page.errorCode && "error-",window.digitalData.page.errorCode,"Payload" ,window.digitalData )}
      } catch (e) {
        this.retry(() => this.trackCTAClick(data, overRideType));
      }
    } else {
      this.failed = type;
      this.retry(() => this.trackCTAClick(data, overRideType));
    }
    sessionStorage.setItem('aviva_ga_cached', JSON.stringify(this.digitalData));
  }

  public retry(callback: any) {
    setTimeout(callback, 10000);
  }

  public recallFailed(): void {
    if (this.failed && window._satellite) {
      window.digitalData = this.digitalData;
      window._satellite.track(this.failed);
      // console.debug('Recall', { type: this.failed, digitalData: this.digitalData, form: this.digitalData.form.name });
      this.failed = null;
    }
  }
}
